import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, Post } from './index';

export interface PostByIdGetParams {
  id: string;
}

export const postById = (payload: PostByIdGetParams): Action<PostByIdGetParams> => ({
  type: actions.postByIdTrigger.toString(),
  payload,
});

export const postByIdClear = (): Action => ({
  type: actions.postByIdClear.toString(),
});

export const postByIdErrorClear = (): Action => ({
  type: actions.postByIdErrorReset.toString(),
});

export function* postByIdRequestSaga({ payload }: Action<PostByIdGetParams>) {
  yield put({
    type: actions.postByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.postByIdError.toString(),
      payload: {
        message: 'PostById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}posts/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<Post, Post>(
    response,
    actions.postByIdSuccess.toString(),
    actions.postByIdError.toString(),
    false,
    (postByIdData) => postByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.postByIdTrigger.toString(),
    defaultProcessingSaga(
      postByIdRequestSaga,
      {
        error: actions.postByIdError.toString(),
        locationCancel: actions.postByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.postByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.postByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.postByIdErrorReset.toString(),
    });
  });
}
